module.exports = __webpack_public_path__ + "static/img/1.ea10c10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/zh/1.png
// module id = MgzQ
// module chunks = 0